import { addMessages, init, getLocaleFromNavigator } from 'svelte-i18n'

import enUS from '../locales/en-US.json'
import de from '../locales/de.json'

addMessages('en', enUS);
// addMessages('en-US', enUS);
addMessages('de', de);
init({
  fallbackLocale: 'en',
  initialLocale: getLocaleFromNavigator(),
});

export default undefined
